<template>
  <div class="full">
    <div class="full overlay">
      <Pipeline ref="pipeline" style="width: 100%; height: 100%;" v-if="toucher" :toucher="toucher" :useBloom="useBloom" :bloomPass="bloomPass">
        <template slot-scope="temp" slot="scene">
          <Particles :amount="200" v-if="temp" :engine="temp"></Particles>
          <!-- <LoadingGL :visible="true" @add-exec="(fn) => { temp.execStack.push(fn) }" :scene="temp.scene" :exec="temp.execStack" :renderer="temp.renderer"></LoadingGL> -->
        </template>
      </Pipeline>
      <div class="overlay" ref="toucher"></div>
    </div>

    <GameLobby @room="onChosenRoom" class="full overlay"></GameLobby>
  </div>
</template>

<script>
import GameLobby from './GameLobby'
export default {
  components: {
    GameLobby,
    Pipeline: require('../game/Pipeline.vue').default,
    Particles: () => import('../game/Particles.vue'),
  },
  data () {
    return {
      toucher: false,
      useBloom: true,
      bloomPass: {
        threshold: 1
      }
    }
  },
  mounted () {
    this.toucher = this.$refs['toucher']
  },
  methods: {
    onChosenRoom (r) {
      // console.log(r)
      window.location.assign('/game-play/' + r.roomID)
    }
  }

}
</script>

<style scoped>
.full{
  width: 100%;
  height: 100%;
}
.overlay{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}
</style>
